module.exports = __webpack_public_path__ + "img/scholarshipTraining.7ff02b9d.jpg";